import { useTranslation } from 'react-i18next'
import { HardDrive } from 'lucide-react'
import { StorageUsage } from '@features/file-explorer/types'
import { formatBytes } from '@utils/formatBytes'

interface StorageUsageBarProps {
  storage: StorageUsage
}

export default function StorageUsageBar({ storage }: StorageUsageBarProps) {
  const { t } = useTranslation()

  const getProgressColor = (percentage: number): string => {
    if (percentage >= 90) return 'bg-error'
    if (percentage >= 75) return 'bg-warning'
    return 'bg-primary'
  }

  return (
    <div className="p-3 border-t border-base-300 bg-base-100">
      <div className="flex items-center gap-2 mb-2">
        <HardDrive className="w-4 h-4 text-base-content/70" />
        <span className="text-xs font-semibold text-base-content/70">
          {t('fileExplorer.storage.title')}
        </span>
      </div>

      <div className="space-y-1">
        {/* Progress bar */}
        <div className="w-full bg-base-300 rounded-full h-2 overflow-hidden">
          <div
            className={`h-full transition-all duration-300 ${getProgressColor(storage.percentage)}`}
            style={{ width: `${Math.min(storage.percentage, 100)}%` }}
          />
        </div>

        {/* Usage text */}
        <div className="flex justify-between items-center text-xs text-base-content/60">
          <span>
            {formatBytes(storage.used)} {t('fileExplorer.storage.of')} {formatBytes(storage.limit)}
          </span>
          <span className="font-medium">
            {storage.percentage.toFixed(1)}%
          </span>
        </div>
      </div>
    </div>
  )
}
